import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import Vak from '../../models/Vak.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const Edit = (props) => {
  
  const navigate = useNavigate();
  const vakObj = new Vak();
  const [vak, setVak] = useState(vakObj.toStateJson());
  const [fetchApi] = getApi('showGlk');
  const [updateApi] = getApi('updateGlks');
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setVak((new Vak(response.data.glk)).toStateJson());
    } catch(error) {
      toast.error("Something went wrong !");
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate('/vak');
      toast.success('VAK updated successfully.');
    } catch(error) {
      vakObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      updateRecord((new Vak(vak)).toApiJson());
    } catch(error){
      setVak(new Vak(vak));
    }
  }

  const handleCancelFunction = () => {
    navigate('/vak');
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.EditVoltUpAllocationKitPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "VAK List", url: '/vak'}, { label: "Edit VAK" }]}
      className={'edit-vak-page'}
    >
      <PageContentWrapper contentHeading={"Edit VAK"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial vak={vak} setVak={setVak} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update VAK</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );

}

export default Edit;
